<template lang="pug">
  v-container(fluid)
    h2.text-center {{ translations.title }}

    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}")
          template(v-slot:item="{ item }")
            tr
              td
                span.fantasy__block-width--8 {{ item.operator ? item.operator.text : '' }}
              td {{ item.name }} : {{ item._id }}
              td {{ item.ncategories }}
              td {{ item.ngames }}
              td(v-if="hasPermission('views.casino.lobby.editLobby')")
                BaseDialog(type="edit", :title="translationsForm.title.edit + item.name" v-slot="{close, opened}")
                  LobbyEdit(@successEdit="updateLobbies(opened,close)", :clearForm="opened", :translations="translationsForm", :lobby="item", :providersList="providerListAll", :operatorsListAll="operatorsListAll")
      BaseDialog(v-if="hasPermission('views.casino.lobby.createLobby')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
        LobbyCreate(@successCreate="updateLobbies(opened,close)", :clearForm="opened", :translations="translationsForm", :providersList="providerListAll", :operatorsListAll="operatorsListAll")

</template>

<script>

  import LobbyCreate from './forms/LobbyCreate';
  import LobbyEdit from './forms/LobbyEdit';

  export default {
    name: "LobbyIndex",
    components: {
      LobbyCreate,
      LobbyEdit,
    },
    // data: () => ({
    // }),
    computed:{
      translations() {
        return this.$t("views.lobbyIndex");
      },
      translationsForm() {
        return this.$t("forms.lobby");
      },
      headers() {
        let headers = [
          {
            text: this.translations.tableHead.operator,
            value: 'operator'
          },
          {
            text: this.translations.tableHead.name,
            value: 'name'
          },
          {
            text: this.translations.tableHead.ncategories,
            value: 'ncategories'
          },
          {
            text: this.translations.tableHead.ngames,
            value: 'ngames'
          },
        ];
        if(this.hasPermission('views.casino.lobby.editLobby')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            }
          );
        }
        return headers;
      },
      datos(){
        return this.lobbiesList.map(lobby =>{
          let operator = { text: '', value: '' }
          if(lobby.b) {
            operator = this.operatorsListAll.find(operator => operator.value === lobby.b)
          }
          return {
            lobby,
            _id: lobby._id,
            name: lobby.n,
            banner: lobby.ban !== undefined && lobby.ban.length > 0 ? lobby.ban.map(banner => ({
                id: banner._id,
                title: banner.t,
                description: banner.d,
                imageDesktop: banner.imgd,
                imageMobile: banner.imgm,
                url: banner.url,
              })): undefined,
            operator,
            providers: lobby.p,
            categories: lobby.c,
            ncategories: lobby.c ? lobby.c.length : 0,
            ngames: lobby.c !== undefined && lobby.c.length > 0 ? lobby.c.reduce((acc,curr)=>{return acc + curr.g.length}, 0) : 0,
          }
        });
      },
      lobbiesList() {
        return this.$store.state.casino.lobbies;
      },
      providerListAll(){
        return this.$store.state.providers.map(provider => ({
          text: provider.n,
          value: provider._id
        })).sort((a, b) => a.text.localeCompare(b.text));
      },
      operatorsListAll(){
        return this.$store.state.operators.map(operator => {
          return{
            text: operator.n,
            value: operator._id
          }
        })
      },
    },
    created() {
      this.$store.dispatch('getLobbies');
      this.$store.dispatch('getProviders');
      this.$store.dispatch('getOperators');
    },
    methods: {
      updateLobbies(opened, closedialog) {
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getLobbies');
        }
      }
    }
  }
</script>

<style lang="sass">
</style>